import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-partner-promotion-V2',
  templateUrl: './partner-promotion-V2.component.html',
  styleUrls: ['./partner-promotion-V2.component.scss']
})
export class PartnerPromotionV2Component implements OnInit {
  @Input() partnerOfferDeals: any;
  @Input() appHostURL: any;
  @Input() currentEnvironment: string;
  @Input() userInfo: any;
  @Input() banner: any;
  @Input() isLoggedInTokenValid: any;
  public productColumnClass = 'col-12 col-sm-6 col-lg-3';
  public productColumnClassV2 = 'col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3';
  constructor() { }

  ngOnInit(): void {
  }

}
